/**
 * 予測検索（2026-08-08）。PCサイドバーの検索窓で入力中に商品候補を出す。
 *
 * データ元は自前の検索JSONビュー（/search?view=sekka-suggest）。
 * 本来は純正の Predictive Search API を使うところだが、このストアでは
 * 417 "Unsupported buyer locale" が返り使えない（ストアのロケール設定起因・
 * テーマから直せないことを2026-08-08に実測確認）。通常検索は生きているので、
 * 結果をJSONで返す専用テンプレート（search.sekka-suggest.liquid）を作って代用。
 * どのストアでも動くのでテーマ製品としてもこちらを正とする。
 * ON/OFFと件数はテーマ設定「mimi 文言と表示 → 予測検索」。
 *
 * 守ること:
 *   - 失敗したら黙って何も出さない。通常の検索（Enterで検索ページ）は常に生きている
 *   - 入力のたびに叩かない（250ms デバウンス）。古いレスポンスは捨てる
 */
(function () {
  var form = document.querySelector('[data-sk-psearch]');
  if (!form) return;
  var input = form.querySelector('input[type="search"]');
  var panel = form.querySelector('[data-sk-psearch-panel]');
  if (!input || !panel) return;

  var LIMIT = parseInt(form.dataset.skPsearch, 10) || 5;
  var timer = 0;
  var seq = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /** APIのpriceは書式が環境で揺れるので、数字だけなら¥を付けて整形、それ以外はそのまま */
  function money(p) {
    if (p == null) return '';
    var s = String(p);
    if (/^\d+(\.\d+)?$/.test(s)) {
      return window.Sekka && window.Sekka.money
        ? window.Sekka.money(Number(s) * 100)
        : String(Math.round(Number(s)));
    }
    return s;
  }

  function close() {
    panel.hidden = true;
    panel.innerHTML = '';
  }

  function render(q, products) {
    if (!products.length) {
      close();
      return;
    }
    var html = products.map(function (p) {
      var imgUrl = p.image
        ? p.image + (p.image.indexOf('?') >= 0 ? '&' : '?') + 'width=88'
        : '';
      var img = imgUrl
        ? '<img src="' + esc(imgUrl) + '" alt="" width="44" height="44" loading="lazy">'
        : '<span class="sk-psearch__noimg"></span>';
      return (
        '<a class="sk-psearch__item" href="' + esc(p.url) + '">' +
        img +
        '<span class="sk-psearch__body">' +
        '<span class="sk-psearch__title"></span>' +
        '<span class="sk-psearch__price">' + esc(money(p.price)) + '</span>' +
        '</span></a>'
      );
    }).join('');
    var T = (window.Sekka && window.Sekka.t) || {};
    html +=
      '<a class="sk-psearch__all" href="/search?q=' +
      encodeURIComponent(q) +
      '">' + esc(T.search_view_all || 'See all results') + '</a>';
    panel.innerHTML = html;
    // 商品名は外から来た文字列なので textContent で入れる
    panel.querySelectorAll('.sk-psearch__item').forEach(function (a, i) {
      a.querySelector('.sk-psearch__title').textContent = products[i].title;
    });
    panel.hidden = false;
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) {
      close();
      return;
    }
    timer = setTimeout(function () {
      var my = ++seq;
      var url = '/search?view=sekka-suggest&type=product&q=' + encodeURIComponent(q);
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (my !== seq) return; // 古いレスポンスは捨てる
          var ps = Array.isArray(d) ? d.slice(0, LIMIT) : [];
          render(q, ps.map(function (p) {
            return { title: p.t, url: p.u, price: p.p, image: p.i };
          }));
        })
        .catch(close);
    }, 250);
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
